/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 * Styled components for Footer
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.25.1
 * @since 1.0.0
 */

import styled from 'styled-components';

import { colors, globalThemeConstants } from '@theme/index';

const FOOTER_HEIGHT = 33;

const FooterContainerStyled = styled.div.attrs({
    className: 'fixed-with-scrollbar',
})`
    position: fixed;
    z-index: 500;
    display: flex;
    justify-content: space-around;
    width: 100%;
    bottom: 0;
    left: 0;
    height: ${FOOTER_HEIGHT}px;
    border-top: solid 1px ${colors.footerBorderColor};
    background-color: ${colors.footerBg};
`;

const FooterBodyStyled = styled.div.attrs({
    className: 'footer',
})`
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    width: ${globalThemeConstants.maxSiteWidth};
    margin-left: auto;
    margin-right: auto;
    align-self: center;
`;

const FooterLinkGroupStyled = styled.div`
    display: flex;
    margin-left: 40px;

    @media (max-width: 1023px) {
        display: none;
    }

    & a {
        text-decoration: none;
        color: ${colors.footerMenuButtonColor};
        margin-right: 24px;
        cursor: pointer;
        font-size: 12px;
    }
    & a:hover {
        color: ${colors.footerMenuButtonColorHover};
    }
`;

const FooterLinkStyled = styled.span`
    white-space: nowrap;
`;

const CopyrightStyled = styled.div`
    display: flex;
    margin-left: 40px;
    margin-right: 40px;
    font-size: 12px;
    color: ${colors.footerCopyrightColor};
    white-space: nowrap;

    .arrow-tooltip__text {
        max-width: 300px;
    }
`;

export {
    CopyrightStyled,
    FooterBodyStyled,
    FooterContainerStyled,
    FooterLinkStyled,
    FooterLinkGroupStyled,
    FOOTER_HEIGHT,
};
